import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/explore')({
  beforeLoad: () => getTitleContextSlice('Explore'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
